import { AlarmEnum, NodeTypes, ProbeTypes } from "../../types/generated_types";

export enum ConstraintEnum {
  GREATER_THAN = ">",
  LESSER_THAN = "<",
}

export interface AlarmTypes {
  alarm_types: Array<AlarmEnum>;
  alarm_constraints: Array<ConstraintEnum>;
}

export interface AlarmData {
  id: number;
  threshold_value?: number;
  constraints?: ConstraintEnum;
  delay_value?: number;
  alarm_type: AlarmEnum;
}

export interface NodeAlarmEndpointData {
  id: number;
  node_name: string;
  node_type: NodeTypes;
  probe_type: ProbeTypes;
  sensor_256_id: number;
  node_alarms: Array<AlarmData>;
}

export interface InstalAndAlarmPk {
  pk: number;
  alarm_id: number;
}

export interface NodeAndAlarmId {
  node_id: number;
  alarm_id: number;
}

export interface Email {
  email: string;
  email_pk: number;
}

export interface InstalAndEmailPk {
  pk: number;
  email_id: number;
}

export interface ConfigInstAlarmParams {
  alarm_type: AlarmEnum;
}

export interface ConfigDataSensAlarmParams {
  threshold_value: number | undefined;
  constraints: ConstraintEnum | undefined;
  alarm_type: AlarmEnum ;
  delay_value: number;
}

export interface InstAddEmailData {
  installation_fk: number;
  email: string;
}

export interface InstChangeEmailData extends InstAddEmailData {
  email_pk: number;
}

export interface AlarmInstallation {
  pk: number;
  name: string;
  unique_id: string;
  email_count: number;
  alarm_count: number;
}

// Alarms/Event log types
export interface AlarmAggregateCommon {
  alarm_start: string
  alarm_end: string
  alarm_type: AlarmEnum
  id: number
}

export interface SensorAlarmAggregate extends AlarmAggregateCommon {
  sensor_256_id: number
  sensor_name: string
  alarm_threshold: number // Only for data alarms
  constraints: ConstraintEnum // Only for data alarms
  alarm_delay: number | null // Only for data alarms
}

export interface InstallationAlarmAggregate extends AlarmAggregateCommon {
  installation_last_online: string
}

export interface SensoralarmDataRecord {
  value: number
  captured_datetime: string
}

export interface SensorAlarmData {
  threshold_value: number
  alarm_type: AlarmEnum
  constraints: ConstraintEnum
  sensor_data: Array<SensoralarmDataRecord>
}
